import type { CheckoutCatalogItem } from '@impact/types';

export interface SelectedCheckoutItem {
  item: CheckoutCatalogItem;
  quantity: number;
}

export function getSelectedCheckoutItems(
  catalogItems: CheckoutCatalogItem[],
  selectedItems: Record<string, number>,
): SelectedCheckoutItem[] {
  const itemsById = new Map(catalogItems.map((item) => [item.id, item] as const));

  return Object.entries(selectedItems)
    .map(([itemId, quantity]) => {
      const item = itemsById.get(itemId);
      if (!item || quantity <= 0) {
        return null;
      }

      return { item, quantity };
    })
    .filter((entry): entry is SelectedCheckoutItem => entry !== null);
}

export function getCheckoutItemsSubtotal(
  catalogItems: CheckoutCatalogItem[],
  selectedItems: Record<string, number>,
): number {
  return getSelectedCheckoutItems(catalogItems, selectedItems).reduce(
    (sum, entry) => sum + entry.item.price * entry.quantity,
    0,
  );
}

export function selectedCheckoutItemsRequireShipping(
  catalogItems: CheckoutCatalogItem[],
  selectedItems: Record<string, number>,
): boolean {
  return getSelectedCheckoutItems(catalogItems, selectedItems).some(
    ({ item }) => item.requiresShipping,
  );
}

export function buildCheckoutItemsInput(
  catalogItems: CheckoutCatalogItem[],
  selectedItems: Record<string, number>,
): Array<{ itemId: string; quantity: number }> {
  return getSelectedCheckoutItems(catalogItems, selectedItems).map(({ item, quantity }) => ({
    itemId: item.id,
    quantity,
  }));
}
